export default __webpack_public_path__ + "static/media/cluster_point_green.6ac30bb0.svg";